import { OrdersMainContainer } from '@/modules/Orders';

const OrdersList = (): JSX.Element => <OrdersMainContainer />;

export default OrdersList;
